import { API_BASE_URL } from "@/utils/getApiBase";
import { request } from "../request";

/**
 * Login
 *
 * @param userName User name
 * @param password Password
 */
export function fetchLogin(userName: string, password: string) {
  return request<Api.Auth.LoginToken>({
    url: "/auth/login",
    method: "post",
    data: {
      userName,
      password,
    },
  });
}

/** Get user info */
export function fetchGetUserInfo() {
  return request<Api.Auth.UserInfo>({ url: "/auth/getUserInfo" });
}

/**
 * Refresh token
 *
 * @param refreshToken Refresh token
 */
export function fetchRefreshToken(refreshToken: string) {
  return request<Api.Auth.LoginToken>({
    url: "/auth/refreshToken",
    method: "post",
    data: {
      refreshToken,
    },
  });
}

export function fetchPing() {
  return request<Api.Auth.PingResponse>({
    url: `${API_BASE_URL}/api/ping/?_=${new Date().getTime()}`,
    method: "get",
  });
}
/**
 * return custom backend error
 *
 * @param code error code
 * @param msg error message
 */
export function fetchCustomBackendError(code: string, msg: string) {
  return request({ url: "/auth/error", params: { code, msg } });
}

export function logoutUser() {
  return request<any>({
    url: `${API_BASE_URL}/api/logout/?_=${new Date().getTime()}`,
    method: "get",
  });
}

export function addPhone(phone: string, otp?: string) {
  return request<any>({
    url: `${API_BASE_URL}/api/auth/v1/addphone/`,
    method: "post",
    data: {
      phone,
      otp,
    },
    metadata: {
      operationType: "write",
      isUserInitiated: true,
      operationName: "addPhone",
      showUserErrors: true,
    },
  } as any);
}
